import ApiService from '@/app/framework/services/ApiServices'
import { MasterDataMapper } from '@/data/persistences/mappers/MasterDataMapper'
import { MasterRepositoryInterface } from '@/data/persistences/repositories/contracts/MasterRepositoryInterface'
import { Master } from '@/domain/entities/Master'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class MasterApiRepository implements MasterRepositoryInterface {
  private service: ApiService
  private mapper: MasterDataMapper

  constructor(service: ApiService, mapper: MasterDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object, type: string): Promise<Master> {
    const resp = await this.service.invoke(
      'get',
      `${Endpoints.Route.MASTER}/${type}`,
      params
    )
    return this.mapper.convertMasterFromApi(resp)
  }

  public async getAllSpesial(params: Object, type: string): Promise<Master> {
    const resp = await this.service.invoke(
      'get',
      `${Endpoints.Route.MASTER}/${type}`,
      params
    )
    return this.mapper.convertMasterFromApi(resp)
  }
}
